import { createSelector } from 'reselect';
import { AviaPassengerType } from '@websky/graphql';
import { getState } from '../rootSelector';
import { getSelectedSeats, getSelectedSeatsWithPricesBySelectedSegmentId } from '../selectedSeats/selectors';
import { getSelectedPassengerId } from '../selectedPassengerId/selectors';
import { getSelectedSegmentId } from '../selectedSegmentId/selectors';
import { getSeatMapSegments } from '../seatMap/selectors';
import { getTotalPrice } from '../../../../../utils';
export const getPassengersState = createSelector(getState, state => state.passengers);
export const getPassengersSelectedSeats = createSelector(getPassengersState, passengers => {
    const selectedSeats = [];
    passengers.forEach(passenger => {
        passenger.selectedSeats.forEach(seat => {
            selectedSeats.push(Object.assign(Object.assign({}, seat), { passengerId: passenger.id }));
        });
    });
    return selectedSeats;
});
export const getPassengersList = createSelector(getPassengersState, getSelectedPassengerId, getSelectedSeatsWithPricesBySelectedSegmentId, (passengers, selectedPassengerId, selectedSeatsWithPricesBySelectedSegmentId) => {
    return passengers.map(passenger => {
        var _a;
        return ({
            id: passenger.id,
            fullName: passenger.fullName,
            isSelected: passenger.id === selectedPassengerId,
            type: passenger.type,
            activeDoubleSeat: passenger.activeDoubleSeat,
            supplierTravellerType: passenger.supplierTravellerType,
            selectedSeats: (_a = selectedSeatsWithPricesBySelectedSegmentId[passenger.id]) !== null && _a !== void 0 ? _a : [],
            seatsPrice: getTotalPrice(selectedSeatsWithPricesBySelectedSegmentId[passenger.id], seat => seat.price),
            isDisabled: passenger.type === AviaPassengerType.INF
        });
    });
});
export const getAvaliablePassengersList = createSelector(getPassengersList, passengers => passengers.filter(passenger => !passenger.isDisabled));
export const getSelectedPassenger = createSelector(getPassengersList, (passengers) => passengers.find(passenger => passenger.isSelected));
export const getIsActiveDoubleSeat = createSelector(getSelectedPassenger, selectedPassenger => selectedPassenger.activeDoubleSeat);
export const getPassengersRecommendedSeats = createSelector(getPassengersState, passengers => {
    let recommendedSeats = {};
    passengers.forEach(passenger => {
        passenger.preselectedSeats.forEach(seat => {
            var _a, _b;
            const travellerRecommendedSeat = {
                segmentId: +seat.segment.id,
                passengerId: +passenger.id,
                row: +seat.seat.row,
                letter: seat.seat.letter,
                price: seat.seat.price,
                comfort: (_a = seat.seat.seatService) === null || _a === void 0 ? void 0 : _a.comfort
            };
            recommendedSeats = Object.assign(Object.assign({}, recommendedSeats), { [+seat.segment.id]: Object.assign(Object.assign({}, ((recommendedSeats === null || recommendedSeats === void 0 ? void 0 : recommendedSeats[+seat.segment.id]) || [])), { [+passenger.id]: [
                        ...(((_b = recommendedSeats === null || recommendedSeats === void 0 ? void 0 : recommendedSeats[+seat.segment.id]) === null || _b === void 0 ? void 0 : _b[+passenger.id]) || []),
                        travellerRecommendedSeat
                    ] }) });
        });
    });
    return recommendedSeats;
});
export const getPassengersRecommendedSeatsBySelectedSegmentId = createSelector(getPassengersRecommendedSeats, getSelectedSegmentId, (recommendedSeats, selectedSegmentId) => { var _a; return (_a = recommendedSeats[selectedSegmentId]) !== null && _a !== void 0 ? _a : {}; });
export const getIsAllSeatsSelected = createSelector(getSelectedSeats, getAvaliablePassengersList, getSeatMapSegments, (selectedSeats, passengers, seatMapSegments) => {
    return Object.values(seatMapSegments).every((segment, segmentId) => {
        if (segment.isSeatsAvailableInCheckinOnly || !segment.availableSeatsCount) {
            return true;
        }
        return (selectedSeats.filter(selectedSeat => selectedSeat.segmentId === segmentId).length === passengers.length);
    });
});
